<template>
    <div class="w-full flex-1 flex flex-col p-2 lg:p-6 space-y-6 lg:pb-18">
        <nav class="flex-grow">
            <template v-for="navItem in navigation" :key="navItem.label">
                <RouterLink :to="{ name: navItem.href }">
                    <NavbarPrimaryItem :class="{ 'is-active': navItem.isActive }">
                        <component :is="navItem.icon" />
                        <span>{{ navItem.label }}</span>
                    </NavbarPrimaryItem>
                </RouterLink>
            </template>
        </nav>
        <div
            class="lg:absolute lg:bottom-0 lg:left-0 lg:ct-bg-2--alt cursor-pointer w-full flex-shrink-0 border-t ct-border-1 border-dotted px-5 h-18 flex items-center space-x-3"
        >
            <template v-if="logged || isImp">
                <div class="relative flex-1 overflow-hidden">
                    <p class="ct-text-2 text-sm font-medium truncate">
                        {{ user.email }}
                    </p>
                </div>
                <ButtonPrimaryMd @click="logMeOut()"> Logout </ButtonPrimaryMd>
            </template>
            <template v-else>
                <ButtonPrimaryMd class="w-full" @click="logMeIn()"> Login </ButtonPrimaryMd>
            </template>
        </div>
    </div>
</template>

<script>
import { markRaw } from "vue";
import { mapGetters, mapState } from "vuex";
import { AvatarSm } from "@easy/ui/avatars";
import {
    LoveIcon,
    LegalIcon,
    PricingIcon,
    PlayerIcon,
    FaqIcon,
    CookieIcon,
    TimerIcon,
    CoffeeIcon,
    PageIcon,
    ImageIcon,
    CogIcon,
    TickerIcon,
} from "@easy/ui/icons";
import { NavbarPrimaryItem } from "@easy/ui/navbars";
import { ButtonPrimaryMd } from "@easy/ui/buttons";
import { LOVE_ROUTE_NAMES } from "@/apps/love/love.routes";
import { LEGAL_ROUTE_NAMES } from "@/apps/legal/legal.routes";
import { PRICING_ROUTE_NAMES } from "@/apps/pricing/pricing.routes";
import { PLAYER_ROUTE_NAMES } from "@/apps/player/player.routes";
import { FAQ_ROUTE_NAMES } from "@/apps/faq/faq.routes";
import { COOKIE_ROUTE_NAMES } from "@/apps/cookie/cookie.routes";
import { TIMER_ROUTE_NAMES } from "@/apps/timer/timer.routes";
import { COFFEE_ROUTE_NAMES } from "@/apps/coffee/coffee.routes";
import { PAGE_ROUTE_NAMES } from "@/apps/page/page.routes";
import { BANNER_ROUTE_NAMES } from "@/apps/banner/banner.routes";
import { TICKER_ROUTE_NAMES } from "@/apps/ticker/ticker.routes";
import { loginService } from "@/auth/service/login.service";

export default {
    name: "cSidebar",
    components: { NavbarPrimaryItem, AvatarSm, ButtonPrimaryMd },
    data() {
        return {
            activeMenu: "menu",
            sidebarOpen: true,
        };
    },
    computed: {
        ...mapState(["user", "lang"]),
        ...mapGetters(["logged", "isImp"]),
        loginLink() {
            return loginService.generateLogInLink(this.lang);
        },
        navigation() {
            return [
                {
                    label: this.$t("shared.list.testimonials.title"),
                    href: LOVE_ROUTE_NAMES.list,
                    icon: markRaw(LoveIcon),
                },
                {
                    label: this.$t("shared.list.pricings.title"),
                    href: PRICING_ROUTE_NAMES.list,
                    icon: markRaw(PricingIcon),
                },
                {
                    label: this.$t("shared.list.legals.title"),
                    href: LEGAL_ROUTE_NAMES.list,
                    icon: markRaw(LegalIcon),
                },
                {
                    label: this.$t("shared.list.players.title"),
                    href: PLAYER_ROUTE_NAMES.list,
                    icon: markRaw(PlayerIcon),
                },
                {
                    label: this.$t("shared.list.faqs.title"),
                    href: FAQ_ROUTE_NAMES.list,
                    icon: markRaw(FaqIcon),
                },
                {
                    label: this.$t("shared.list.cookies.title"),
                    href: COOKIE_ROUTE_NAMES.list,
                    icon: markRaw(CookieIcon),
                },
                {
                    label: this.$t("shared.list.timers.title"),
                    href: TIMER_ROUTE_NAMES.list,
                    icon: markRaw(TimerIcon),
                },
                {
                    label: this.$t("shared.list.coffees.title"),
                    href: COFFEE_ROUTE_NAMES.list,
                    icon: markRaw(CoffeeIcon),
                },
                {
                    label: this.$t("shared.list.pages.title"),
                    href: PAGE_ROUTE_NAMES.list,
                    icon: markRaw(PageIcon),
                },
                {
                    label: this.$t("shared.list.banners.title"),
                    href: BANNER_ROUTE_NAMES.list,
                    icon: markRaw(ImageIcon),
                },
                {
                    label: this.$t("shared.list.tickers.title"),
                    href: TICKER_ROUTE_NAMES.list,
                    icon: markRaw(TickerIcon),
                },
                {
                    label: this.$t("shared.list.settings"),
                    href: LOVE_ROUTE_NAMES.settings,
                    icon: markRaw(CogIcon),
                },
            ];
        },
    },
    methods: {
        logMeIn() {
            location.href = this.loginLink;
        },
        async logMeOut() {
            await loginService.logOut();
        },
    },
};
</script>
